//import unmetNeeds from '../Views/01_unmet-needs/index.cshtml';
//import moa from '../Views/02_moa/index.cshtml';
//import studyDesign from '../Views/03_studydesign/index.cshtml';

import aboutPadcev from '../Views/01_aboutPadcev/index.cshtml';
import populationPost from '../Views/02_populationPost/index.cshtml';
import populationCisplatin from '../Views/03_populationCisplatin/index.cshtml';
import dosingAdministration from '../Views/04_dosingAdministration/index.cshtml'; 

import { updateArray } from "../assets/views/00_common/userActions";


//import dosingAndAdmin from '../Views/04_dosing-and-admin/index.cshtml';
 
//import overallSurvival from '../Views/05_overallSurvival/index.cshtml';
//import pfsOrr from '../Views/06_pfsOrr/index.cshtml';
//import qualityOfLife from '../Views/07_qualityOfLife/index.cshtml';
//import safety from '../Views/08_safety/index.cshtml';  

import videojs from 'video.js';

import Lottie from 'lottie-web';


import PathUpdate from './PathUpdate';

import content from '../content.json';
 

import { createEl } from './utils'; 


export default class Views {
  constructor(state) {
    this.state = state;
 
    this.viewsArray = this.state.views;  
    this.views = []; 
    this.el = createEl('div', { className: 'views' });

    this.update = this.update.bind(this);
    this.close = this.close.bind(this);
    this.hideAllViews = this.hideAllViews.bind(this);
    this.hide = this.hide.bind(this);
     
    
    /// singleton instance to update audio/tabbing
    this._path = PathUpdate.getInstance();	    
    
    
    /// create the view elements
	//this.views.unmetNeeds = createEl('div', { className: 'view hidden', innerHTML: unmetNeeds });
	  //this.views.moa = createEl('div', { className: 'view hidden', innerHTML: moa });
	  this.views.aboutPadcev = createEl('div', { className: 'view hidden', innerHTML: aboutPadcev });
	  this.views.populationPost = createEl('div', { className: 'view hidden', innerHTML: populationPost });
	  this.views.populationCisplatin = createEl('div', { className: 'view populationCisplatinView hidden', innerHTML: populationCisplatin });
	  this.views.dosingAdministration = createEl('div', { className: 'view hidden', innerHTML: dosingAdministration });




    //this.views.studyDesign = createEl('div', { className: 'view hidden', innerHTML: studyDesign });
    //this.views.dosingAndAdmin = createEl('div', { className: 'view hidden', innerHTML: dosingAndAdmin });

    //this.views.overallSurvival = createEl('div', { className: 'view hidden', innerHTML: overallSurvival });
    //this.views.pfsOrr = createEl('div', { className: 'view hidden', innerHTML: pfsOrr });
    //this.views.qualityOfLife = createEl('div', { className: 'view hidden', innerHTML: qualityOfLife });
    //this.views.safety = createEl('div', { className: 'view hidden', innerHTML: safety });

	const _this = this;



	   

	/// loop append elements/ create animation players
	this.viewElms = {
		//"unmetNeeds" : { "elm" : this.views.unmetNeeds},
		//"moa": { "elm": this.views.moa },
		"aboutPadcev": { "elm": this.views.aboutPadcev },
		"populationPost": { "elm": this.views.populationPost },
		"populationCisplatin": { "elm": this.views.populationCisplatin },
		"dosingAdministration": { "elm": this.views.dosingAdministration }




		//"studyDesign" : {"elm" :this.views.studyDesign}
		//"dosingAndAdmin" : {"elm" :this.views.dosingAndAdmin},
		//"overallSurvival": {"elm" :this.views.overallSurvival},
		//"pfsOrr" : {"elm" :this.views.pfsOrr},
		//"qualityOfLife" : {"elm" :this.views.qualityOfLife},
		//"safety" : {"elm" :this.views.safety}		
	};

	for (var key in this.viewElms) {
		let item = _this.viewElms[key];
		  _this.el.appendChild( item.elm );
		  
		  let plyr_1 = item.elm.querySelector('.lottie-player-win');
		  let plyr_2 = item.elm.querySelector('.lottie-player-win_loop');	 
		  
		  /// two animations loop and intro
		  /// create the lottie player with code and append it to dom
		  _this.viewElms[key].plyr1 = Lottie.loadAnimation({
			  container: plyr_1, 
			  renderer: 'svg',
			  loop: false,
			  autoplay: true,
			  path: '/assets/ani/view_window.json'
			});				
		  _this.viewElms[key].plyr2 = Lottie.loadAnimation({
			  container: plyr_2, 
			  renderer: 'svg',
			  loop: true,
			  autoplay: true,
			  path: '/assets/ani/view_window_loop.json'
			});			
	}



	
    if (module.hot) {
    
		module.hot.accept('../Views/01_aboutPadcev/index.cshtml', () => { this.views.aboutPadcev.innerHTML = aboutPadcev; });
		module.hot.accept('../Views/02_populationPost/index.cshtml', () => { this.views.populationPost.innerHTML = populationPost; });
		module.hot.accept('../Views/03_populationCisplatin/index.cshtml', () => { this.views.populationCisplatin.innerHTML = populationCisplatin; });
		module.hot.accept('../Views/04_dosingAdministration/index.cshtml', () => { this.views.dosingAdministration.innerHTML = dosingAdministration; });





    }	

    
    
  
	/// assign close action to all close buttons
	window.addEventListener('DOMContentLoaded', (event) => {
		let o =  _this.el.querySelectorAll('.view .close');
		let _body = document.body;
		let hasOutroPlayed = false;
		
		o.forEach(function(btn) {
			btn.addEventListener('click', function(e){
				_this._path.update('closeView');
				_this.state.view = null;


				let outro1 = localStorage.getItem('tab_aboutPadcev');
				let outro2 = localStorage.getItem('tab_populationPost');
				let outro3 = localStorage.getItem('tab_populationCisplatin'); 
				let outro4 = localStorage.getItem('tab_dosingAdministration'); 

				if ((outro1 == "complete") && (outro2 == "complete") && (outro3 == "complete") && (outro4 == "complete")) {

					if (!hasOutroPlayed) {
						_this.state.popup = 'outro';
						hasOutroPlayed = true;
                    }

				

				}

				
				
			});
		});	
		
		
		
		//var player = videojs('moa-video', {}, function onPlayerReady() {
		//  /// safari bug z-index issues
		//  this.on('fullscreenchange', function() {
		//	if (_body.classList.contains('isFullScreenVid')) {
		//		_body.classList.remove('isFullScreenVid');
		//	} else {
		//		_body.classList.add('isFullScreenVid');
		//	}
		//  });
		//});		
	});   
   
    
  }
  


  update(previous, current) {
    
	/// hide all 
	this.hideAllViews();	

	/// use a string or index:
	let srch = content.views.findIndex(x => x.name === current)
	current = (srch >= 0 ) ? srch : current;



	/// show view
    if (current !== null){ 
    	let _this = this;
    	let _view = this.views[content.views[current].name];  
		if (typeof _view !== 'undefined' && _view) {

	
			_view.classList.remove('hidden');

		
			 

			//document.getElementById("tab_" + this.state.view + "_1").classList.add("tab-visited");
			//document.getElementById("menu_btn_" + this.state.view).classList.add("visited");


    		
    		/// reset tabbed content to first tab
			var radio = _view.querySelectorAll('input[type=radio]');
		
			
 			if(radio[0] && radio[1]){
				radio[0].checked = true;
				radio[1].checked = false;
				radio.forEach(function (item, idx) {
					item.addEventListener('change', function () {

						
						this.classList.add("tab-visited");
						

						var data_menu = this.getAttribute('data-menu'); 
						var data_menu_id = this.getAttribute('id'); 
					
						

						localStorage.setItem("active_tab", data_menu_id);

						//console.log(data_menu_id);

						//console.log(data_menu_id);


						var menu_tab_items;

						switch (data_menu_id) {
							case 'tab_aboutPadcev_1':
								menu_tab_items = 'About_Padcev_UnmetNeed';
								break;
							case 'tab_aboutPadcev_2':
								menu_tab_items = 'About_Padcev_TreatmentLandscape';
								break;
							case 'tab_aboutPadcev_3':
								menu_tab_items = 'About_Padcev_MOA';
								break;
							case 'tab_aboutPadcev_4':
								menu_tab_items = 'About_Padcev_MOAVideo';
								break;

							case 'tab_populationPost_1':
								menu_tab_items = '301_Trial_Overview_StudyDesign';
								break;
							case 'tab_populationPost_2':
								menu_tab_items = '301_Trial_Overview_PatientCharacteristics';
								break;

							case 'tab_populationCisplatin_1':
								menu_tab_items = '301_Trial_Results_Results';
								break;
							case 'tab_populationCisplatin_2':
								menu_tab_items = '301_Trial_Results_Safety';
								break;
							case 'tab_populationCisplatin_3':
								menu_tab_items = '301_Trial_Results_QOL';
								break;

							case 'tab_dosingAdministration_1':
								menu_tab_items = 'Dosing_Administration_DandA';
								break;
							case 'tab_dosingAdministration_2':
								menu_tab_items = 'Dosing_Administration_DoseMods';
								break;
						}

						//trackingVar
						//console.log(menu_tab_items);


						updateArray(menu_tab_items); 


						///// 


						var sounds = document.getElementsByTagName('audio');
						for (i = 0; i < sounds.length; i++) sounds[i].pause();

						var playr1 = document.querySelector("#aud_" + data_menu_id);
						

						if (playr1) {

							/// start the audio, check for delay attribute 
							let d = 0, _this = this;
							if (playr1.getAttribute('delay')) {
								d = playr1.getAttribute('delay') * 1000;
							}

							/// settimeout delay (0 if no delay)

							setTimeout(function () {
								if (playr1) {
									
									//console.log("audio found");
									playr1.currentTime = 0;
									playr1.play();
								}
							}, d);
						}



				/////



						document.getElementById(data_menu).classList.add("visited");


						//console.log(this.classList[0]);

						let elements = document.querySelectorAll("." + this.classList[0]);
						var isValid = true;

						for (var i = 0; i < elements.length; i++) {
							if (!(elements[i].classList.contains("tab-visited"))) {
								isValid = false;

							}
						}

						if (isValid) {
							localStorage.setItem(this.classList[0], 'complete');
						}



						 



						_this._path.stopAllVideo();
						if(item.getAttribute('data-new_tabindx')){
							_this._path.update(item.getAttribute('data-new_tabindx'));
						}
					});
				});				

 			}
  
  			/// play the animation
    		if(typeof this.viewElms[content.views[current].name] !== 'undefined'){
  				let _v = this.viewElms[content.views[current].name];
				let player = _v.plyr1;
				let player_loop = _v.plyr2;
				if(player_loop){
					player_loop.wrapper.style.opacity=0;
				}
				
				/// two animations, after into, play loop
				if(player){
					player.wrapper.style.opacity=1;
					player.goToAndPlay(0); 
					player.addEventListener('complete', function(e){
						if(player_loop){
							player.wrapper.style.opacity=0;
							player_loop.wrapper.style.opacity=1;
						}  									
					});
				}  		
    		}
    		

    	}
     } 
	
  } 

	/// signal to close the view
	close() {
		this.state.view = null;


	}

	/// hide element containing all views
	hide(){
		this.el.classList.add('hidden');   
	}

	/// hide all views in view element
	hideAllViews(){
		for( let elm in this.views) {		
			if(!this.views[elm].classList.contains('hidden')) this.views[elm].classList.add('hidden');  	
		}  		
	}
  
}


